import { useCurrentEditor } from '@tiptap/react';
import { Tooltip } from '../../tooltip';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button } from '../../button';
import Icon from '../../icon/icon';
export function HeadingButton(props) {
    const { editor } = useCurrentEditor();
    if (!editor) {
        return null;
    }
    const disabled = !editor.isEditable;
    const isActive = !disabled && editor.isActive('heading', { level: props.level });
    return (React.createElement(Tooltip, { content: `Heading ${props.level}`, disabled: disabled },
        React.createElement(EditorButton, { isActive: isActive, text: `H${props.level}`, onClick: () => editor.chain().focus().toggleHeading({ level: props.level }).run(), disabled: disabled || !editor.can().chain().focus().toggleHeading({ level: props.level }).run() })));
}
export function HistoryButtons() {
    const { editor } = useCurrentEditor();
    // State for determining whether to disable History Buttons
    const [hasTyped, setHasTyped] = useState(false);
    const handleEditorChange = useCallback(() => {
        if ((editor === null || editor === void 0 ? void 0 : editor.getText().length) !== 0) {
            setHasTyped(true);
            editor === null || editor === void 0 ? void 0 : editor.off('update', handleEditorChange);
        }
    }, []);
    useEffect(() => {
        if ((editor === null || editor === void 0 ? void 0 : editor.getText().length) !== 0)
            setHasTyped(true);
        editor === null || editor === void 0 ? void 0 : editor.on('update', handleEditorChange);
    }, []);
    if (!editor) {
        return null;
    }
    const disabled = !editor.isEditable || !hasTyped;
    console.log('GetText', editor === null || editor === void 0 ? void 0 : editor.getHTML());
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { content: "Undo" },
            React.createElement(EditorButton, { StartIcon: React.createElement(Icon, { name: "reload" }), onClick: () => editor.chain().focus().undo().run(), disabled: disabled || !editor.can().undo() })),
        React.createElement(Tooltip, { content: "Redo" },
            React.createElement(EditorButton, { StartIcon: React.createElement(Icon, { name: "reload", style: { transform: 'scaleX(-1)' } }), onClick: () => editor.chain().focus().redo().run(), disabled: disabled || !editor.can().redo() }))));
}
export function EditorTextStyleButton({ styleType, ...props }) {
    const { editor } = useCurrentEditor();
    if (!editor) {
        return null;
    }
    const disabled = !editor.isEditable;
    const label = uppercaseWord(styleType);
    const isActive = !disabled && editor.isActive(styleType);
    return (React.createElement(Tooltip, { content: label, disabled: disabled },
        React.createElement(EditorButton, { isActive: isActive, text: label[0], onClick: () => editor.chain().focus().toggleMark(styleType).run(), disabled: disabled || !editor.can().chain().focus().toggleMark(styleType).run(), ...props })));
}
function uppercaseWord(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
}
export const EditorButton = styled(Button).attrs((props) => ({
    size: 'small',
    variant: props.isActive ? 'filled' : 'transparent'
})) `
  width: 30px;
  padding: 0;
  aspect-ratio: 1;
`;
